import {
  timezoneName,
  timezoneOffset
} from 'lib/utils/timezone';

export const getBrowserTimezone = () => {
  return {
    name: timezoneName,
    offset: timezoneOffset,
  };
};
